import { createTheme } from "@mui/material/styles";

export function getTheme(themeMode) {
  return createTheme({
    palette: {
      mode: themeMode,
      background: {
        default: themeMode === 'light' ? '#e6e4c4' : '#000000',
      },
      componentBackground: {
        default: themeMode === 'light' ? '#e0e0e0' : '#303030',
      },
      primary: {
        main: themeMode === 'light' ? '#4c38e3' : '#ffffff',
      },
      secondary: {
        main: themeMode === 'light' ? '#f44336' : '#ffffff',
      },
      text: {
        primary: themeMode === 'light' ? '#000000' : '#ffffff',
        secondary: themeMode === 'light' ? '#000000' : '#ffffff',
      },
    },
  });
}
